import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "infinite-scroll-content" }

import { IonInfiniteScroll } from '@ionic/vue';
import BasicEntryDocumentList from './BasicEntryDocumentList.vue';
import BasicSpinner from './../BasicSpinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicDocumentListWithInfiniteScroll',
  props: {
    documents: null,
    maxDocuments: null,
    route: null
  },
  emits: ['loadMore'],
  setup(__props: any, { emit }) {

const props = __props as {
  documents: Document[],
  maxDocuments: number,
  route: string,
};





const onInfiniteScroll = (event) => {
  emit('loadMore');
  event.target.complete()
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasicEntryDocumentList, {
      documents: props.documents,
      route: props.route
    }, {
      default: _withCtx(({ document }) => [
        _renderSlot(_ctx.$slots, "default", { document: document })
      ]),
      _: 3
    }, 8, ["documents", "route"]),
    _createVNode(_unref(IonInfiniteScroll), { onIonInfinite: onInfiniteScroll }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createVNode(BasicSpinner, { "is-loading": true })
        ], 512), [
          [_vShow, props.documents.length < props.maxDocuments]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})